import { Component, Input, Output, EventEmitter } from '@angular/core';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'cmat-selector',
  templateUrl: './t_selector.component.html',
  styleUrls: ['./selector.component.less']
})
export class SelectorComponent {

	opened:boolean = false;

	_value:any;

	get value()
	{
		return this._value;
	}

	set value(v)
	{
		this._value = v;
		this.changeTriggered.emit(this._value);
	}


	@Input('values') values:Array<any>;
	@Input('title') title:string = 'Filtrer';
	@Input('default') default: string = "tout";
	@Input('prop') prop: string = '';

	@Output()
	changeTriggered: EventEmitter<any> = new EventEmitter();

	remove()
	{
		this.value=null;
	}

	setValueFromProp(prop, value)
	{
		if(prop == this.prop
		&& this._value != value) this._value = value;
	}

}
